/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable new-cap */
/* eslint-disable import/prefer-default-export */
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

/**
 * Sanitize a filename by replacing invalid characters with underscores
 * @param {string} name
 * @returns {string}
 */
const sanitizeFileName = (name) =>
  // Remove leading/trailing spaces and replace invalid characters
  name.trim().replace(/[\\/\\:*?"<>|]/g, '_');
export const downloadPDF = async (element, fileName) => {
  if (!element) {
    console.error('No element provided for PDF generation.');
    return;
  }

  const safeFileName = sanitizeFileName(fileName || 'document');

  // Rendering resolution. 2 = crisp but heavy; 1.5 keeps table text sharp at a
  // fraction of the file size. JPEG quality for the embedded page images.
  const CAPTURE_SCALE = 1.5;
  const JPEG_QUALITY = 0.8;

  try {
    const fullHeight = Math.max(element.scrollHeight, element.offsetHeight);
    const fullWidth = Math.max(element.scrollWidth, element.offsetWidth);
    const canvas = await html2canvas(element, {
      scale: CAPTURE_SCALE,
      scrollX: 0,
      scrollY: 0,
      // JPEG has no alpha channel; force an opaque white background so
      // transparent areas don't render as black.
      backgroundColor: '#ffffff',
      // Capture the element's full rendered size, not just the viewport area,
      // so long tables spanning many pages aren't clipped.
      height: fullHeight,
      width: fullWidth,
      windowHeight: fullHeight,
      windowWidth: fullWidth,
    });

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfPageHeight = pdf.internal.pageSize.getHeight();

    // How many source-canvas pixels map to one A4 page height.
    const pageCanvasHeight = Math.floor((canvas.width * pdfPageHeight) / pdfWidth);

    // Slice the tall capture into one image per page and embed each slice ONCE.
    // (The previous approach re-embedded the entire full-height image on every
    // page, multiplying the file size by the page count.)
    let renderedHeight = 0;
    let pageIndex = 0;

    while (renderedHeight < canvas.height) {
      const sliceHeight = Math.min(pageCanvasHeight, canvas.height - renderedHeight);

      const pageCanvas = document.createElement('canvas');
      pageCanvas.width = canvas.width;
      pageCanvas.height = sliceHeight;

      const ctx = pageCanvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      ctx.drawImage(
        canvas,
        0, renderedHeight, canvas.width, sliceHeight,
        0, 0, canvas.width, sliceHeight,
      );

      const imgData = pageCanvas.toDataURL('image/jpeg', JPEG_QUALITY);
      const sliceHeightMm = (sliceHeight * pdfWidth) / canvas.width;

      if (pageIndex > 0) pdf.addPage();
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, sliceHeightMm);

      renderedHeight += sliceHeight;
      pageIndex += 1;
    }

    pdf.save(`${safeFileName}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};
